'use strict';
/*global _:true*/
/*global angular:true*/
/*global moment:true*/
/*global Stripe:true*/
/*global AppConfig:true*/
/**
 * @example
 * <code>
 *      <input account />
 * </code>
 * @name Account - Utility to format and validate Stripe Bank Account number
 */
function Account() {
    function link(scope, element, attrs, ctrl) {
        var country = attrs.country === 'CA' ? 'CA' : 'US';
        element.on('keyup', function () {
            scope.$apply(function () {
                var v = Stripe.bankAccount.validateAccountNumber(element.val(), country);
                ctrl.$setValidity('validaccount', v);
            });
        });
        /**
         * Cleanup - try to destroy memory leak substible 
         */
        function cleanup() {
            if (angular.isElement(this)) { return scope.$destroy(); }
            if (typeof angular.element(element).off === 'function') { angular.element(element).off(); }
            if (element && typeof $(element).off === 'function') {
                $(element).off();
            }
            if (element && typeof element.off === 'function') { element.off(); }
        }
        scope.$on('$destroy', cleanup);
        element.on('$destroy', cleanup);
    }

    return {
        restrict: 'A',
        require: 'ngModel',
        link: link
    };

}
angular.module('hoogy').directive('account', Account);
